





















  import { defineComponent, computed } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'OneListingBrandsInfo',
    props: {
      selectedFilters: {
        type: Object,
        required: true,
      },
    },
    setup(props) {
      const vm = useCurrentInstance()
      const brand = computed(() => {
        const brandFilter = props.selectedFilters?.brand
        if (brandFilter?.length === 1) {
          return vm.$store.getters['brands/getBrandByName'](brandFilter[0])?.brand || null
        }
        return null
      })

      const series = computed(() => {
        const seriesFilter = props.selectedFilters?.productSeries
        if (seriesFilter?.length === 1) {
          return vm.$store.getters['brands/getSeriesByName'](seriesFilter[0]) || null
        }
        return null
      })

      const selectedCategoryName = computed<string | null>(() => {
        const selectedCategory = vm.$store.getters['categories/getSelectedCategory']
        return selectedCategory?.name || null
      })

      return {
        brand,
        series,
        selectedCategoryName,
      }
    },
  })
